// extracted by mini-css-extract-plugin
module.exports = {"thumb":"BaseThumb_thumb_3_-7-","spinAround":"BaseThumb_spinAround_Oyj6g"};